<template>
  <div>
    <v-speed-dial v-model="fab" center direction="left" open-on-hover>
      <template v-slot:activator>
        <v-btn v-if="isResp === false && rowData.status === 'Error'" v-model="fab" :color="rowData.color" x-small dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-eye</v-icon>
        </v-btn>
        <v-btn v-if="isResp === true && rowData.respStatus === 'Error'" v-model="fab" :color="rowData.respColor" x-small dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-eye</v-icon>
        </v-btn>
      </template>
      <v-tooltip top v-if="isResp === false && rowData.status === 'Error'">
        <template v-slot:activator="{ on }">
          <v-btn fab dark x-small color="info" v-on="on" @click="retryConfirmation()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Retry</span>
      </v-tooltip>
      <v-tooltip top v-if="isResp === true && rowData.respStatus === 'Error'">
        <template v-slot:activator="{ on }">
          <v-btn fab dark x-small color="info" v-on="on" @click="retryConfirmation()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Retry</span>
      </v-tooltip>
      <v-tooltip top v-if="isResp === false && rowData.status === 'Error'">
        <template v-slot:activator="{ on }">
          <v-btn fab dark x-small :color="rowData.color" v-on="on" @click="doShowError()">
            <v-icon>{{ rowData.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ rowData.status }}</span>
      </v-tooltip>
      <v-tooltip top v-if="isResp === true && rowData.respStatus === 'Error'">
        <template v-slot:activator="{ on }">
          <v-btn fab dark x-small :color="rowData.respColor" v-on="on" @click="doShowRespError()">
            <v-icon>{{ rowData.respIcon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ rowData.respStatus }}</span>
      </v-tooltip>
    </v-speed-dial>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fab: false
    }
  },
  props: {
    rowData: {
      type: Object,
      default: () => {}
    },
    isResp: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    retryConfirmation() {
      this.$emit('retryConfirmation', this.rowData)
    },
    doShowError() {
      this.$emit('showError', this.rowData)
    },
    doShowRespError() {
      this.$emit('showRespError', this.rowData)
    }
  }
}
</script>
